import { CSSProperties, PropsWithChildren } from "react";
import classnames from "classnames";

import styles from "./map-control-overlay.module.css";

type MapOverlayProps = {
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  style?: CSSProperties;
};

const MapControlPositioner = ({
  position = "top-left",
  style,
  children,
}: PropsWithChildren<MapOverlayProps>) => {
  return (
    <div
      className={classnames(styles.controlPositioner, {
        [styles.positionLeft]: position.includes("left"),
        [styles.positionRight]: position.includes("right"),
        [styles.positionTop]: position.includes("top"),
        [styles.positionBottom]: position.includes("bottom"),
      })}
      style={style}
    >
      {children}
    </div>
  );
};

export default MapControlPositioner;
